/**
 * Validates a plain text name using a regular expression.
 *
 * @param {string | undefined} name - The name to be validated.
 * @return {string | undefined} - Returns an error message if the name is invalid, otherwise undefined.
 */
export const isInvalidName = (name: string | undefined) => {
  const nameRegex = /^[A-Za-z\W]+$/
  if (!name?.length) {
    return 'Name is required'
  } else if (!nameRegex.test(name)) {
    return 'Please enter a valid name'
  } else {
    return undefined
  }
}
